export const environment = {
  production: false,
  link: 'http://localhost',
  name: 'development environment',
  code: 1001,
  // link_api_test:'https://fakestoreapi.com/'
  link_api_test:'https://api.escuelajs.co/api/v1/',
  link_api_dev:'http://demo.sys.corp/api/',

  name_app:"SISGESTOUR",


  txt_create_menu_form:"Registrar",
  txt_edit_menu_form:"Editar",

  max_size_img: 0.500,
  max_size_file: 1,
  max_number_img: 20,
};
